import { createAction } from '@reduxjs/toolkit';

export const analyticsAddBankAccountFlowViewed = createAction(
    'ANALYTICS::ADD_BANK_ACCOUNT_FLOW::VIEWED',
);

export const analyticsConfirmBankAccountFlowViewed = createAction(
    'ANALYTICS::CONFIRM_BANK_ACCOUNT_FLOW::VIEWED',
);

export const analyticsConfirmBankAccountFlowSuccess = createAction(
    'ANALYTICS::CONFIRM_BANK_ACCOUNT_FLOW::SUCCESS',
);

export const analyticsAddBankAccountOTPViewed = createAction(
    'ANALYTICS::ADD_BANK_ACCOUNT_OTP::VIEWED',
);
